import { createSlice } from "@reduxjs/toolkit";

const adminSlice = createSlice({
  name: "admin",
  initialState: {
    adminDetails: [],
    clientBrands: null,
    openDrawer: false,
    permissions: [],
    fullPageLoader: false,
    findValues: {
      navBarHeight: 0,
    },
  },
  reducers: {
    updateAdminDetails: (state, action) => {
      state.adminDetails = [action.payload].flat();
    },
    updateClientBrands: (state, action) => {
      state.clientBrands = action.payload;
    },
    updateDrawer: (state, action) => {
      state.openDrawer = !state.openDrawer;
    },
    updatePermission: (state, action) => {
      state.permissions = action.payload;
    },

    updateLoader: (state, action) => {
      state.fullPageLoader = !state.fullPageLoader;
    },

    updateFindValues: (state, action) => {
      state.findValues = {
        ...state.findValues,
        ...action.payload,
      };
    },
  },
});

export const {
  updateAdminDetails,
  updateClientBrands,
  updateDrawer,
  updatePermission,
  updateLoader,
  updateFindValues,
} = adminSlice.actions;
export default adminSlice.reducer;
